<script lang="ts" setup>
const route = useRoute();

definePageMeta({
  layout: "funnel",
  vertical: "BB",
  pageTransition: {
    name: "",
    mode: "out-in",
  },
  middleware: ["funnel"],
});

watch(
  () => route.fullPath,
  () => {
    useStoryblokContent();
  },
  {
    immediate: true,
  }
);
</script>

<template>
  <div class="page-container">
    <NuxtPage :page-key="(route) => route.fullPath" />
  </div>
</template>
